import { FeedApiModel } from '@cxb/editor-stb-api';
import { Feed } from '../../domain/feed';

/* eslint-disable prefer-arrow/prefer-arrow-functions */

export function mapFeed(feed: FeedApiModel): Feed {
  return {
    // TODO:CXBMERGE:AB FeedApiModel should have a string type ID
    id: `${feed.id}`,
    title: feed.title,
    guid: feed.guid,
    updated: feed.updated,
    referringPages: [...new Set(feed.referringPageNames)],
  };
}
